import classNames from 'classnames'

import {showCartSyncModal} from '../Modals/CartSyncModal/cartSyncModalFunctions.js'
import {useSelector} from '../../store.js'
import {areTasksRunningSelector} from '../../data/tasks.js'

export default function SyncButton() {
  const areTasksRunning = useSelector(areTasksRunningSelector)

  return (
    <button
      className={classNames('btn btn--primary btn--primary-alt btn--nav-sync', {
        'btn--processing': areTasksRunning,
      })}
      type="button"
      onClick={() => showCartSyncModal()}
    >
      SYNC
    </button>
  )
}
